module.exports = __webpack_public_path__ + "img/ia-01-6.861319c3.jpg";